import classNames from 'classnames'
import { ReactNode } from 'react'
export const INPUT_FORM_COMMON_SIZE = 'w-[300px] md:w-[400px]'
export const INPUT_FORM_COMMON_SIZE_WIDE = 'w-[300px] md:w-[500px]'
export function OverlayWrapper({
  children,
  className = INPUT_FORM_COMMON_SIZE,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <div className={classNames('mx-auto my-8 flex flex-col items-center', className)}>
      {children}
    </div>
  )
}
